import { createContext, useContext } from 'react'
import { useMutation } from '@apollo/client'
import { v4 as uuidv4 } from 'uuid'

// import useRefreshAuthToken from './useRefreshAuthToken' // TODO: Add this back to the process
import { apolloAuthData, client } from '../services/apollo'
import {
  deletePersistedAuthData,
  setPersistedAuthData,
  LOGIN_USER,
} from '../services/auth'
import { getProfilePic } from '../utils'

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [logIn, { loading: signingIn }] = useMutation(LOGIN_USER)
  // const authData = useReactiveVar(apolloAuthData)
  const authData = apolloAuthData()

  const signin = async (
    email,
    password,
    setFormMessage = () => {},
    callback = () => {}
  ) => {
    try {
      setFormMessage({ type: 'info', text: 'Authenticating...' })
      const response = await logIn({
        variables: {
          clientMutationId: uuidv4(),
          username: email,
          password,
        },
      })

      const loginAuthData = {
        authToken: response?.data?.login?.authToken,
        refreshToken: response?.data?.login?.refreshToken,
        user: response?.data?.login?.user,
      }
      setAuthData(loginAuthData)

      // Grab the user profile picture
      setFormMessage({ type: 'info', text: 'Getting profile...' })

      try {
        const profilePicURL = await getProfilePic(
          response?.data?.login.user.profilePic
        )

        setAuthData(
          {
            authToken: loginAuthData.authToken,
            refreshToken: loginAuthData.refreshToken,
            user: { ...response?.data?.login?.user, profilePicURL },
          },
          callback
        )
      } catch {
        setAuthData(
          {
            ...response?.data?.login,
            user: {
              ...response?.data?.login?.user,
              profilePicURL: '',
              profilePic: '',
            },
          },
          callback
        )
      }
    } catch (err) {
      throw err
    }
  }

  let value = {
    ...authData,
    isManager: authData?.user?.capabilities?.includes('manager'),
    isFacilitator: authData?.user?.capabilities?.includes('facilitator'),
    signin,
    signingIn,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  return useContext(AuthContext)
}

export const setAuthData = (authData, callback = () => {}) => {
  const { authToken, refreshToken, user } = authData

  // Persist the data in the local storage
  setPersistedAuthData({ authToken, refreshToken, user })

  // Save data in the reactive var
  apolloAuthData({ authToken, refreshToken, user })

  // Call the callback function
  callback()
}

export const deleteAuthData = (callback = () => {}) => {
  apolloAuthData({
    authToken: null,
    refreshToken: null,
    user: null,
  })

  // Remove data in local storage
  deletePersistedAuthData()

  // Clear Apollo client cache store and force all active queries to be
  // refetched
  client.resetStore()

  callback()
}
